import React, { useEffect } from "react";
import { Exercise } from "../../../models/Exercise";
import useCalendarSale from "../../ThreeStep/hooks/useCalendarSale";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { MODAL_TEST, TOUR_DETAILS } from "../../../routes";
import {
  setExerciseName,
  setExerciseZoneId,
  setExerciseDescription,
} from "../../../store/pseudoModal/pseudoModalsActions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { State } from "../../../store";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";
import { applyMainPriceTemplate } from "../../shared/ProductBanner/parseBannerPrice";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import useGetLowestPrice from "../../../../utils/hooks/useGetLowestPrice";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import { replaceVariablesInString } from "../../CustomOffer/OfferModules/replaceVariablesInString";
import useParentMessage from "../../../../utils/hooks/useParentMessage";

interface IProps {
  exercise: Exercise;
  saleStep?: SaleStep;
  highlightedFeatures?: string[];
}

const SingleAvailAbleExercise: React.FC<IProps> = ({ exercise, saleStep, highlightedFeatures }: IProps) => {
  const { scrollToTop } = useParentMessage();
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const ids = useSelector((state: State) => state.config.facilityIds);
  const navigate = useNavigate();
  const { getTicketsByExercise, tickets } = useCalendarSale();
  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup, exercise);
    //eslint-disable-next-line
  }, []);
  const dispatch = useDispatch();

  const updateState = () => {
    // Sprawdzamy, czy mamy wariant tras koncertowych
    const isToursVariant = saleStep?.toursScheduleVariant === true;

    // Wybieramy odpowiedni URL docelowy w zależności od wariantu
    const targetUrl = isToursVariant ? TOUR_DETAILS : MODAL_TEST;

    let newUrl = `${targetUrl}?id=${ids}&exerciseName=${encodeURIComponent(exercise.name)}&exerciseIds=${
      exercise.zone.objectId
    }`;

    if (saleStep?.id) {
      newUrl += `&saleStepId=${saleStep.id}`;
    }

    if (exercise.location) {
      newUrl += `&location=${encodeURIComponent(exercise.location)}`;
    }

    navigate(newUrl);
    dispatch(setExerciseName(exercise.name));
    dispatch(setExerciseZoneId(exercise.zone.objectId));
    dispatch(setExerciseDescription(exercise.description));

    scrollToTop();
  };

  const lowestPrice = useGetLowestPrice(tickets, isDesktop, !saleStep?.mainPrice);

  return (
    <EAProductBanner
      title={exercise.name}
      pictureUrl={exercise.eventMessage}
      description={exercise.description}
      mainPrice={saleStep?.mainPrice ? applyMainPriceTemplate(saleStep.mainPrice, lowestPrice) : lowestPrice}
      configuredPrice={Boolean(saleStep?.mainPrice)}
      crossedPrice={saleStep?.crossedPrice ? saleStep.crossedPrice.replace("{{price}}", lowestPrice) : ""}
      buttonTitle={t("wybierz")}
      onClick={() => updateState()}
      highlightBanner={saleStep?.highlightBanner}
      bannerLabel={replaceVariablesInString(saleStep?.bannerLabel || "", exercise)}
      additionalPriceInfo={saleStep?.priceLabel}
      highlightedFeatures={highlightedFeatures}
      loginRequired={saleStep?.loginRequired}
    />
  );
};

export default SingleAvailAbleExercise;
